// extracted by mini-css-extract-plugin
export default {"statusIndicator":"aSZ_DpzkA75fTI6YVlyH","clickable":"Rynx3Ic4VQMP2N8fA4wQ","label":"VVeeqav5qdCMMxpT76DS","colorDot":"EUaJn2X3hbXnPzEg_8Kq","compact":"DlOZl1V6ETSwNIkZFzeZ"};